<template>
  <v-container fluid>
    <v-card v-if="loader" class="fill-height" style="padding: 50px" elevation="0">
      <v-nodata
        :loading="loading.timesheetOption"
        :networkError="networkError.timesheetOption"
        @retryMethod="getAttendanceData"
        title=""
        msg-details="There is no attendance details"
        icon="filter_tilt_shift"
        content-bg="lighten-4"
      >
      </v-nodata>
    </v-card>

    <v-card v-else-if="Object.keys(attendanceData).length > 0" class="mx-auto">
      <v-img
        :src="getImage(attendanceData.image, false)"
        @click="zoom(attendanceData.image)"
        class="white--text align-end"
        height="200px"
        srtyle="background-color:gray"
      >
        <v-card-title
          >{{ attendanceData.accounts.firstName }}
          {{ attendanceData.accounts.lastName }}</v-card-title
        >
      </v-img>

      <v-card-text>
        <!-- <v-container grid-list-md> -->
        <v-layout row wrap>
          <v-flex xs3 sm3 md3 style="padding: 5px 0px">Time :</v-flex>
          <v-flex xs6 sm6 md6 style="padding: 5px 0px">
            
            <!-- <datetime
              v-if="
                canSee('modifyTimesheet') || attendanceData.userId == $store.state.userDetails.id
              "
              v-model="selectedPunchTime"
              :button-confirm="timeCompare()"
              type="datetime"
              class="dateCustomInput"
              format="yyyy-MM-dd hh:mm a"
              confirm
            >
              <span slot="before" class="description">
                <v-icon style="margin-bottom: -2px;">calendar_today</v-icon>
              </span>
            </datetime> 

            <datetime
              v-else
              v-model="selectedPunchTime"
              type="datetime"
              class="dateCustomInput"
              format="yyyy-MM-dd hh:mm a"
              confirm
              disabled
            >
              <span slot="before" class="description">
                <v-icon style="margin-bottom: -2px;">calendar_today</v-icon>
              </span>
            </datetime> -->

            <v-datetime-picker  v-if="canSee('modifyTimesheet') || attendanceData.userId == $store.state.userDetails.id"
              v-model="selectedPunchTime"
              :button-confirm="timeCompare()"
              time-format="HH:mm:ss"
              date-format="yyyy-MM-dd"
              >
            </v-datetime-picker>

             <v-datetime-picker  v-else
              v-model="selectedPunchTime"
              time-format="HH:mm:ss"
              date-format="yyyy-MM-dd"
              confirm
              disabled
              >
              </v-datetime-picker>

            <v-flex v-if="showTimeChangeBtn" xs12 sm12 md6 style="margin: 2px">
              <v-btn
                @click="resetTime()"
                v-if="!changeStatusButton"
                style="margin: 3px; font-size: 13px"
                color="red"
                class="white--text"
                >Cancel</v-btn
              >
              <v-btn
                @click="timeChangeRequest(attendanceData.userId)"
                :disabled="changeStatusButton"
                :loading="changeStatusButton"
                style="margin: 3px; font-size: 13px"
                color="success"
                class="white--text"
                >Change Time</v-btn
              >
            </v-flex>
          </v-flex>

          <v-flex xs3 sm3 style="padding: 5px 4px; text-align: right;">
            <v-chip v-if="attendanceData.timezone" color="primary" label text-color="white">
              <v-avatar>
                <v-icon class="white--text">history</v-icon>
              </v-avatar>
              {{ selectedPunchTime | moment("timezone", attendanceData.timezone.name, "z") }}
            </v-chip>
          </v-flex>

          <v-flex xs3 sm3 md3 style="padding: 5px 0px">Check In/Out :</v-flex>

          <v-flex xs9 sm9 md9 style="padding: 5px 0px">
            <v-chip
              v-if="
                canSee('modifyTimesheet') || attendanceData.userId == $store.state.userDetails.id
              "
              :color="colorCalc(attendanceData.punchType)"
              @click="statusChange(attendanceData.punchType)"
              class="white--text"
              label
              small
            >
              {{ attendanceData.punchType }}
              <v-icon class="white--text">edit</v-icon>
            </v-chip>

            <v-chip
              v-else
              :color="colorCalc(attendanceData.punchType)"
              class="white--text"
              label
              small
            >
              {{ attendanceData.punchType }}
              <v-icon class="white--text">edit</v-icon>
            </v-chip>
          </v-flex>

          <v-flex v-if="changeCheckinFlex" xs3 sm3 md3 style="padding: 5px 0px"
            >Changed Check In/Out:</v-flex
          >

          <v-flex v-if="changeCheckinFlex" xs9 sm9 md9 style="padding: 5px 0px">
            <v-chip :color="colorCalc(changedStatus.status)" label text-color="white" small>
              <v-avatar>
                <v-icon class="white--text">location_on</v-icon>
              </v-avatar>
              {{ changedStatus.status }}
            </v-chip>

            <v-flex v-if="showCheckinChangeBtn" xs12 md12 sm12 style="margin: 2px">
              <v-btn
                v-if="!changeStatusButton"
                @click="resetStatus()"
                style="margin: 3px; font-size: 13px"
                color="red"
                depressed
                class="white--text"
                >Cancel</v-btn
              >

              <v-btn
                :disabled="changeStatusButton"
                :loading="changeStatusButton"
                @click="statusChangeRequest()"
                style="margin: 3px; font-size: 13px"
                color="success"
                depressed
                class="white--text"
                >Change Punch Type</v-btn
              >
            </v-flex>
          </v-flex>

          <v-flex xs3 sm3 md3>Punch Location:</v-flex>

          <v-flex v-if="attendanceData.location" xs9 sm9 md9>
            <v-chip
              v-if="
                canSee('modifyTimesheet') || attendanceData.userId == $store.state.userDetails.id
              "
              @click="locationChange(attendanceData.userId)"
              color="primary"
              label
              text-color="white"
            >
              <v-avatar>
                <v-icon class="white--text">location_on</v-icon>
              </v-avatar>
              {{ attendanceData.location.name }}
              <v-icon class="white--text">edit</v-icon>
            </v-chip>

            <v-chip v-else color="info" label text-color="white">
              <v-avatar>
                <v-icon class="white--text">location_on</v-icon>
              </v-avatar>
              {{ attendanceData.location.name }}
              <v-icon class="white--text">edit</v-icon>
            </v-chip>
          </v-flex>

          <v-flex v-if="changeLocationFlex" xs3 sm3 md3>Changed Location:</v-flex>

          <v-flex v-if="changeLocationFlex" xs9 sm9 md9 style="padding: 5px 0px">
            <v-chip color="orange" label text-color="white">
              <v-avatar>
                <v-icon class="white--text">location_on</v-icon>
              </v-avatar>
              {{ changedLocation.name }}
            </v-chip>

            <v-flex v-if="showLocationChangeBtn" xs12 sm12 md12 style="margin: 2px">
              <v-btn
                v-if="!changeStatusButton"
                @click="resetLocation()"
                color="red"
                style="margin: 3px; font-size: 13px"
                class="white--text"
                >Cancel</v-btn
              >

              <v-btn
                :disabled="changeStatusButton"
                :loading="changeStatusButton"
                @click="locationChangeRequest()"
                color="success"
                style="margin: 3px; font-size: 13px"
                class="white--text"
                >Change Location</v-btn
              >
            </v-flex>
          </v-flex>

          <v-flex
            v-if="attendanceData.address"
            xs12
            sm12
            md12
            style="padding: 0px 15px; text-align: center"
          >
            <h3 style="opacity : 0.7">{{ attendanceData.address.display_name }}</h3>
          </v-flex>

          <v-flex v-if="'gps' in attendanceData" xs12 sm12 md12>
            <p>GPS :</p>
            <GmapMap
              :center="punchData.coordinates"
              :zoom="20"
              map-type-id="terrain"
              style="min-width: 200px; min-height: 400px;width:100%"
            >
              <GmapMarker
                v-if="
                  canSee('modifyTimesheet') || attendanceData.userId == $store.state.userDetails.id
                "
                :position="punchData.coordinates"
                :clickable="true"
                :draggable="true"
                @dragend="updateLoc"
                :icon="{
                  url: require('@/assets/ft.png'),
                  size: { width: 45, height: 45, f: 'px', b: 'px' },
                  scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
                }"
              />

              <GmapMarker
                v-else
                :position="punchData.coordinates"
                :clickable="false"
                :draggable="false"
                :icon="{
                  url: require('@/assets/ft.png'),
                  size: { width: 45, height: 45, f: 'px', b: 'px' },
                  scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
                }"
              />

              <GmapMarker
                v-if="punchData.location != undefined"
                :position="punchData.location.coordinates"
                :label="punchData.location.name"
                :icon="{
                  url: require('@/assets/ft.png'),
                  size: { width: 45, height: 45, f: 'px', b: 'px' },
                  scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
                }"
              />
            </GmapMap>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="punchData.coordinates.lat"
                    label="In Lat"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="punchData.coordinates.lng"
                    label="In Long"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <v-flex v-if="cancelChangeBtn" xs12 sm6 md6>
            <v-btn
              @click="cordChangeRequest()"
              :disabled="changeStatusButton"
              :loading="changeStatusButton"
              color="success"
              class="white--text"
              >Change Location</v-btn
            >

            <v-btn v-if="!changeStatusButton" @click="resetMap()" color="error" class="white--text"
              >Cancel</v-btn
            >
          </v-flex>

          <v-flex v-if="attendanceData.change.length > 0" xs12 sm12 md12 style="margin: 10px 0px">
            <v-card elevation="1">
              <v-card-title class="primary">
                <h3 style="margin: 0px" class="reg__heading">Changes</h3>
              </v-card-title>
              <v-card-text style="padding: 5px 7px">
                <v-timeline dense>
                  <v-slide-x-reverse-transition group hide-on-leave>
                    <v-timeline-item
                      v-for="item in attendanceData.change"
                      :key="item.id"
                      :color="colorOnState(item.state)"
                      small
                    >
                      <v-card
                        :value="true"
                        style="padding: 0px; border-radius: 3px"
                        color="#5975ff"
                        icon="settings"
                      >
                        <v-card-title>
                          <v-flex xs12 md8>
                            <h4
                              style="color: #fff; letter-spacing: 0.5px; font-size: 17px; line-height: 20px; margin: 5px 0px; font-weight: 500"
                            >
                              {{ nameOfChange(item.changeType) }}
                            </h4>
                            <h5
                              style="color: #fff; line-height: 20px; font-size: 14px; font-weight: 400"
                            >
                              Requested for: {{ getName(item.userId) }}
                            </h5>
                            <h5
                              v-if="$store.getters.userDetails.role.toLowerCase() != 'user'"
                              style=" font-weight: 400; line-height: 20px; color: #fff; font-size: 14px"
                            >
                              Requester: {{ getName(item.requester) }}
                            </h5>
                          </v-flex>

                          <v-flex xs12 md4>
                            <div v-if="item.state == 2">
                              <v-chip color="error" style="color: #fff; font-weight: 500"
                                >Rejected</v-chip
                              >
                            </div>
                            <div v-else-if="item.state == 0">
                              <v-chip color="warning" style="color: #1a1a1a; font-weight: 500"
                                >Pending</v-chip
                              >
                            </div>
                            <div v-else>
                              <v-chip color="success" style="color: #fff; font-weight: 500"
                                >Approved</v-chip
                              >
                            </div>
                          </v-flex>
                        </v-card-title>

                        <v-card-text>
                          <v-list-item-title
                            v-if="item.changeType == 'securityFlag'"
                            style="color: #fff;white-space: inherit!important;text-overflow: clip!important;"
                            class="changeTime_"
                          >
                            Raised Flags for :
                            <p>{{ item.meta.flags.join(",") }}</p>
                          </v-list-item-title>

                          <v-list-item-title
                            v-if="item.changeType == 'changeTime'"
                            style="color: #fff"
                            class="changeTime_"
                          >
                            Requested Punch Time:
                            <p>{{ item.meta.time | moment("dddd, MMMM Do YYYY, h:mm a") }}</p>
                          </v-list-item-title>

                          <v-list-item-title
                            v-if="item.changeType == 'changePunchLocation'"
                            style="color: #fff; font-size: 15px; font-weight: 500;"
                          >
                            Requested Punch Location:
                            <p
                              style="font-weight: 400; letter-spacing: 0.5px;line-height: 20px; color: #fff; font-size: 13px"
                            >
                              {{ getLocationName(item.meta.locationId) }}
                            </p>
                          </v-list-item-title>

                          <v-list-item-title
                            v-if="item.changeType == 'changePunchType'"
                            style="color: #fff"
                          >
                            Requested Punch Type:
                            <p>{{ item.meta.punchType }}</p>
                          </v-list-item-title>
                        </v-card-text>
                        <v-card-actions>
                          <div v-if="item.state == 0">
                            <!-- <v-layout row>
                              <v-flex xs12 sm4>-->
                            <v-btn
                              v-if="
                                $store.state.userDetails.id == attendanceData.accounts.supervisor
                              "
                              :disabled="changeStatusButton"
                              @click="approveChanges(item)"
                              style="margin: 6px; text-transform: none"
                              small
                              color="success"
                              class="white--text"
                              ripple
                              >Approve</v-btn
                            >
                            <!-- </v-flex>
                              <v-flex xs12 sm4>-->
                            <v-btn
                              v-if="
                                $store.state.userDetails.id == attendanceData.accounts.supervisor
                              "
                              :disabled="changeStatusButton"
                              @click="rejectChanges(item)"
                              small
                              style="margin: 6px; text-transform: none"
                              color="error"
                              class="white--text"
                              ripple
                              >Reject</v-btn
                            >
                            <!-- </v-flex>
                              <v-flex xs12 sm4>-->
                            <v-btn
                              v-if="$store.state.userDetails.id == item.requester"
                              :disabled="changeStatusButton"
                              @click="cancelChanges(item)"
                              small
                              style="margin: 6px; text-transform: none"
                              color="error"
                              class="white--text"
                              ripple
                              >Cancel Request</v-btn
                            >
                            <!-- </v-flex>
                              </v-layout>-->

                            <!--Show to admin -->

                            <!--Show to user-->
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-timeline-item>
                  </v-slide-x-reverse-transition>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- </v-container> -->
      </v-card-text>

      <v-spacer></v-spacer>
    </v-card>

    <v-dialog v-model="dialog3" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ ErrormMsg }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn @click="dialog3 = false" color="primary" flat>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLocation" max-width="290">
      <v-card>
        <v-card-title class="primary">
          <h3 style="margin: 0px" class="reg__heading">Select Location</h3>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="item in generateLocationList"
              :key="item.id"
              @click="locationSelectedCompare(item)"
              avatar
            >
              <v-list-item-avatar>
                <v-icon class="blue lighten-1 white--text">location_on</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatus" max-width="290">
      <v-card>
        <v-card-title class="headline">Select Punch Type</v-card-title>
        <v-list two-line subheader>
          <v-list-item
            v-for="item in checkinStatus"
            :key="item.status"
            @click="statusSelectedCompare(item)"
          >
            <v-list-item-avatar>
              <v-icon class="blue lighten-1 white--text">location_on</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.status }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogZoom" max-width="40vw" content-class="reg__boxShadowHide">
      <img :src="selectedZoomImage" @click.stop="dialogZoom = false" alt="" width="100%" />
    </v-dialog>
  </v-container>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";
//import { Datetime } from "vue-datetime";
//import "vue-datetime/dist/vue-datetime.css";
import canSee from "@/utilities/canSee";
import VNodata from "@/components/Unavailable/nodata.vue";

export default {
  components: { VNodata },
  //components: { DatePicker, datetime: Datetime, VNodata },
  data: () => ({
    loader: false,
    loading: {
      timesheetOption: true
    },
    networkError: {
      timesheetOption: false
    },
    allUsers: [],
    selectedZoomImage: "",
    dialogZoom: false,
    changeCheckinFlex: false,
    checkinStatus: [
      {
        status: "IN"
      },
      {
        status: "OUT"
      }
    ],
    dialogStatus: false,
    showCheckinChangeBtn: false,
    changedStatus: {},
    userData: "",
    generateLocationList: [],
    dialogLocation: false,
    showLocationChangeBtn: false,
    changeLocationFlex: false,
    changedLocation: {},
    attendanceDetails: [],
    clipped: false,
    attendanceId: "",
    attendanceData: {},
    showTimeChangeBtn: false,
    ErrormMsg: "",
    dialog3: false,
    userName: "",
    selectedPunchTime: "",
    staticPunchTime: "",
    cancelChangeBtn: false,
    punchData: {
      coordinates: {
        lat: 12.33,
        lng: 14.88
      }
    },
    staticPunchData: {
      coordinates: {
        lat: 12.33,
        lng: 14.88
      }
    },
    inTime: "",
    outTime: "",
    changeStatusButton: false
  }),

  watch: {
    $route(to, from) {
      // react to route changes...

      if (from.path != to.path) {
        this.init();
      }
    }
  },
  async created() {
    this.init();
    // await this.getAllUser()

    this.$http
      .get(
        `${this.$store.state.endpoint}Accounts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
      )
      .then(
        response => {
          this.allUsers = response.body;
        },
        error => {
          // console.log(error);
        }
      );
  },
  methods: {
    zoom(url) {
      var fullPath = "";

      if (url == undefined) {
        fullPath = require("@/assets/demo.png");
        //return demoImg;
      } else {
        fullPath = this.$store.state.imagePath + url;
      }

      this.dialogZoom = true;
      this.selectedZoomImage = fullPath;
    },
    getImage(src, small) {
      if (src == undefined) {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }

      if (small) {
        src = src.insert(src.lastIndexOf("."), "_200x200");
      }

      return this.$store.state.imagePath + src;
    },
    canSee(what, role) {
      return canSee(this, what, role);
    },
    getName(value) {
      const userData = this.allUsers;

      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].firstName} ${userData[o].lastName}`;
        }
      }
    },
    colorOnState(e) {
      switch (e) {
        case 0:
          return "warning";
          break;
        case 1:
          return "success";
          break;

        case 2:
          return "error";
          break;
      }
    },

    nameOfChange(e) {
      switch (e) {
        case "deleteAttendance":
          return "Delete Request";
          break;
        case "imageMissing":
          return "Image Error Approve Request";
          break;
        case "wifiMismatch":
          return "Wifi Mismatch Approve Request";
          break;
        case "changeLocation":
          return "Location Modification Request";
          break;
        case "changePunchType":
          return "Punch Type Modification Request";
          break;
        case "changePunchLocation":
          return "Punch Location  Modification Request";
          break;
        case "changeTime":
          return "Time Modification Request";
          break;
        case "outOfLocation":
          return "Out Of Location Approve Request";
          break;
        case "securityFlag":
          return "Security Error Approve Request";
          break;
        case "manualPunch":
          return "Manual Punch";
          break;
      }
    },
    init() {
      this.attendanceId = this.$route.params.attendanceId;
      this.userName = ""; // get attendance name

      this.getAttendanceData();
    },

    getLocationName(value) {
      const locationData = this.generateLocationList;
      for (const o in locationData) {
        if (locationData[o].id == value) {
          return locationData[o].name;
        }
      }
    },

    locationSelectedCompare(item) {
      if (this.attendanceData.location.id != item.id) {
        this.showLocationChangeBtn = true;
        this.changeLocationFlex = true;
        this.changedLocation = item;
        this.dialogLocation = false;
      } else {
        this.showLocationChangeBtn = false;
        this.dialogLocation = false;
      }
    },
    statusSelectedCompare(item) {
      if (this.attendanceData.punchType != item.status) {
        this.showCheckinChangeBtn = true;
        this.changeCheckinFlex = true;
        this.changedStatus = item;
        this.dialogStatus = false;
      } else {
        this.showCheckinChangeBtn = false;
        this.dialogStatus = false;
      }
    },

    locationChange() {
      this.dialogLocation = true;
    },
    statusChange() {
      this.dialogStatus = true;
    },
    locationChangeRequest() {
      this.changeStatusButton = true;
      const postObj = {
        attendanceId: this.attendanceId,
        changeType: "changePunchLocation",
        userId: this.$store.state.userDetails.id,
        meta: {
          locationId: this.changedLocation.id
        }
      };

      const self = this;

      this.$http
        .post(`${this.$store.state.endpoint}attendances/applyAttendanceChange`, postObj)
        .then(
          response => {
            // success callback

            self.resetLocation();
            self.getAttendanceData();
            self.changeStatusButton = false;
          },
          error => {
            console.log(error);
            self.changeStatusButton = false;
            this.$swal({ type: "error", text: error.body.error.message });
            return error;
            // error callback
          }
        );
    },
    resetLocation() {
      this.changeLocationFlex = false;
      this.showLocationChangeBtn = false;
    },

    statusChangeRequest() {
      this.changeStatusButton = true;
      const postObj = {
        attendanceId: this.attendanceId,
        changeType: "changePunchType",
        userId: this.$store.state.userDetails.id,
        meta: {
          punchType: this.changedStatus.status
        }
      };

      const self = this;

      this.$http
        .post(`${this.$store.state.endpoint}attendances/applyAttendanceChange`, postObj)
        .then(
          response => {
            self.resetStatus();
            self.getAttendanceData();
            this.changeStatusButton = false;
          },
          error => {
            console.log(error);
            this.changeStatusButton = false;
            this.$swal({ type: "error", text: error.body.error.message });
            return error;
          }
        );
    },
    resetStatus() {
      this.changeCheckinFlex = false;
      this.showCheckinChangeBtn = false;
    },

    colorCalc(c) {
      return c === "OUT" ? "error" : "success";
    },
    timeChangeRequest(userid) {
      const self = this;

      if(self.selectedPunchTime == null || self.selectedPunchTime == "") {
        self.$swal({type: "warning", text: "Invalid Date and Time"})
        return
      }

      self.$http.get(`${self.$store.state.endpoint}Accounts/${userid}`).then(response => {
        var selectedUserTz = response.body.tz;

        var punchDataTime = moment(self.selectedPunchTime)
          .tz(selectedUserTz.name, true)
          .format();

        var today = moment().format("DD/MM/YYYY HH:mm:ss");

        var inputDate = moment(punchDataTime).format("DD/MM/YYYY HH:mm:ss");

        var duration = moment(today, "DD/MM/YYYY HH:mm:ss").diff(
          moment(inputDate, "DD/MM/YYYY HH:mm:ss"),
          "seconds"
        );

        if (duration < 0) {
          self.$swal({
            type: "error",
            text: "Future date punches not allowed"
          });
          return;
        }

        self.changeStatusButton = true;
        const postObj = {
          attendanceId: self.attendanceId,
          changeType: "changeTime",
          userId: self.$store.state.userDetails.id,
          meta: {
            time: moment(self.selectedPunchTime).format("YYYY-MM-DDTHH:mm:ss")
          }
        };

        self.$http
          .post(`${self.$store.state.endpoint}attendances/applyAttendanceChange`, postObj)
          .then(
            response => {
              // success callback

              self.resetTime();
              self.getAttendanceData();
              this.changeStatusButton = false;
            },
            error => {
              this.changeStatusButton = false;
              console.log(error);
              this.$swal({ type: "error", text: error.body.error.message });
              return error;
              // error callback
            }
          );
      });

      self.changeStatusButton = false;

     

    },
    cordChangeRequest() {
      this.changeStatusButton = true;
      const postObj = {
        attendanceId: this.attendanceId,
        changeType: "changeLocation",
        meta: {
          gps: this.punchData.coordinates
        },
        userId: this.$store.state.userDetails.id
      };

      const self = this;
      this.$http
        .post(`${this.$store.state.endpoint}attendances/applyAttendanceChange`, postObj)
        .then(
          response => {
            // success callback
            self.changeStatusButton = false;
            self.resetMap();
            self.getAttendanceData();
          },
          error => {
            // console.log(error);
            self.changeStatusButton = false;
            this.$swal({ type: "error", text: error.body.error.message });
            return error;
            // error callback
          }
        );
    },

    updateLoc(location) {
      this.punchData.coordinates.lat = location.latLng.lat();
      this.punchData.coordinates.lng = location.latLng.lng();
      this.cordsCompare();
    },
    cordsCompare() {
      if (
        this.punchData.coordinates.lat != this.staticPunchData.coordinates.lat ||
        this.punchData.coordinates.lng != this.staticPunchData.coordinates.lng
      ) {
        this.cancelChangeBtn = true;
      }
    },
    resetMap() {
      const oldCord = {
        lat: this.staticPunchData.coordinates.lat,
        lng: this.staticPunchData.coordinates.lng
      };

      this.punchData.coordinates = oldCord;
      this.cancelChangeBtn = false;
      this.changeStatusButton = false;
    },
    resetTime() {
      const oldTime = this.staticPunchTime;
      console.log(oldTime)
      this.selectedPunchTime = ""
      this.selectedPunchTime = moment(this.staticPunchTime).format('YYYY-MM-DD HH:mm:ss')
      this.showTimeChangeBtn = false;
    },

    timeCompare() {
      console.log(moment(this.selectedPunchTime).valueOf(), moment(this.staticPunchTime).valueOf());

      if (moment(this.selectedPunchTime).valueOf() != moment(this.staticPunchTime).valueOf()) {
        this.showTimeChangeBtn = true;
      } else {
        this.showTimeChangeBtn = false;
      }
    },

    // async getAllUser(){
    //   var response = await this.$http.get(`${this.$store.state.endpoint}/accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}`)

    // },

    // getRequesterName (id) {

    // },

    getAddress(gps) {
      return new Promise((resolve, reject) => {
        try {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ location: gps }, (results, status) => {
            if (status === "OK") {
              if (results[1]) {
                resolve(results[1].formatted_address);
              } else {
                resolve("");
              }
            }
          });
        } catch (e) {
          console.log(e);
          resolve("");
        }
      });
    },

    getAttendanceData() {
      this.loader = true;
      this.attendanceData = {};
      this.$http
        .get(
          `${this.$store.state.endpoint}attendances/${this.attendanceId}?filter[include]=location&filter[include][accounts]=allowedLocation`
        )
        .then(
          async response => {
            if (typeof response.body.location == "undefined") {
              response.body.location = {
                name: "Deleted Location"
              };
            }

            var data = response.body;

            this.generateLocationList = data.accounts.allowedLocation;

            const offset = Number(data.timezone.offset);

            this.selectedPunchTime = moment(data.time).format('YYYY-MM-DD HH:mm:ss')

            this.staticPunchTime = moment(data.time)
              .utcOffset(offset)
              .format("YYYY-MM-DDTHH:mm:ss");

            this.punchData.location = data.location;
            if (typeof data.gps === "undefined") {
              const defaultOutGps = {
                lat: "",
                lng: ""
              };
              this.punchData.coordinates = defaultOutGps;
              this.staticPunchData.coordinates = defaultOutGps;
            } else {
              const Gps = {
                lat: response.body.gps.lat,
                lng: response.body.gps.lng
              };
              this.punchData.coordinates = response.body.gps;
              this.staticPunchData.coordinates = Gps;
            }

            if ("gps" in data && !("address" in data)) {
              data.address = {
                display_name: await this.getAddress(data.gps)
              };
            }
            this.$set(this, "attendanceData", data);

            console.log(this.attendanceData);

            this.loader = false;
          },
          error => {
            console.log(error);
            this.loader = false;
            if (error.status == 500) {
              this.$router.push({ name: "Timesheet" });
            } else {
              this.$swal({
                type: "error",
                text: error.body.error.message
              });
            }
          }
        );
    },
    approveChanges(item) {
      this.changeStatusButton = true;
      this.$http
        .post(
          `${this.$store.state.endpoint}attendances/${this.$route.params.attendanceId}/${item.id}/approve`
        )
        .then(
          response => {
            // success callback

            if (item.changeType == "deleteAttendance") {
              // this.$router.go(-1)
              this.$router.push("/timesheet");
            } else {
              this.getAttendanceData();
            }

            this.changeStatusButton = false;
          },
          error => {
            console.log(error);
            this.changeStatusButton = false;
            // error callback
            this.$swal({
              type: "error",
              text: "Something went wrong. Try again later"
            });
          }
        );
    },
    rejectChanges(item) {
      this.changeStatusButton = true;
      this.$http
        .delete(`${this.$store.state.endpoint}attendances/${this.attendanceId}/${item.id}/reject`)
        .then(
          response => {
            // success callback

            // if(response.body ==""){
            this.changeStatusButton = false;
            this.$router.push("/timesheet");
            // }else{
            // this.getAttendanceData()
            // }
          },
          error => {
            console.log(error);
            this.changeStatusButton = false;
            return error;
            // error callback
          }
        );
    },
    cancelChanges(item) {
      // If change is outOfLocation/imageMissing/wifiMismatch then delete the attendance since user is wanting to cancel the request itself
      this.changeStatusButton = true;
      if (
        item.changeType == "outOfLocation" ||
        item.changeType == "imageMissing" ||
        item.changeType == "wifiMismatch" ||
        item.changeType == "manualPunch" ||
        item.changeType == "securityFlag"
      ) {
        // TODO Security
        this.$http
          .delete(`${this.$store.state.endpoint}attendances/${this.attendanceId}/delete`)
          .then(
            response => {
              // success callback
              this.changeStatusButton = false;

              this.$router.go(-1);
            },
            error => {
              console.log(error);
              this.changeStatusButton = false;
              // error callback
            }
          );
      } else {
        this.$http
          .delete(
            `${this.$store.state.endpoint}attendances/${this.attendanceId}/changes/${item.id}`
          )
          .then(
            response => {
              // success callback
              this.changeStatusButton = false;

              this.getAttendanceData();
            },
            error => {
              console.log(error);
              this.changeStatusButton = false;
              // error callback
            }
          );
      }

      // else
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.v-content {
  padding: 7% 0 0 !important;
}
.status_ {
  font-size: 15px;
  letter-spacing: 0.4px;
  font-weight: bold;
}
.changeTime_ {
  font-size: 14px;
  letter-spacing: 0.4px;
  color: #161616;
}
</style>
